import React from 'react';
import styled from 'styled-components';
import { IAttachment } from '../../interfaces/attachment.interface';

const StyledDiv = styled.div`
  ${(props: { isWide: boolean }) =>
    props.isWide
      ? `float: left;
      padding-bottom: 8px;
      padding-top: 7px;
      width: calc(24vw - 60px);`
      : `padding: 0px 6px 0px 6px;`}
`;

const StyledSpan = styled.span`
  background: #ebf7fe;
  border: 1px solid #00a0f0;
  border-radius: 10px;
  box-sizing: border-box;
  color: #333333;
  display: inline-block;
  font-size: 14px;
  text-decoration: none;
  overflow: hidden;
  padding: 5px 20px 4px 5px;
  box-sizing: border-box;
  text-overflow: ellipsis;
  white-space: nowrap;
  position: ${(props: { isWide: boolean }) =>
    props.isWide ? 'absolute' : 'relative'};
  width: ${(props: { isWide: boolean }) => (props.isWide ? 'inherit' : '80%')};
  ${(props: { isWide: boolean }) => (props.isWide ? `line-height: 21px;` : ``)}
`;

const DeleteStyledSpan = styled.span`
  position: absolute;
  top: 9px;
  right: 4px;
  content: '';
  display: block;
  width: 13px;
  height: 14px;
  background: url(/images/close_button.png) 0 0 no-repeat;
  background-size: 100%;
  z-index: 1;
  cursor: pointer;
`;

const DisableStyledSpan = styled.span`
  position: absolute;
  top: 9px;
  right: 4px;
  content: '';
  display: block;
  width: 13px;
  height: 14px;
  background: url(/images/close_button.png) 0 0 no-repeat;
  background-size: 100%;
  opacity: 0.25;
  z-index: 0;
`;

interface Props {
  attachment: IAttachment;
  isWide: boolean;
  onClick: Function;
}

export const Attachment = (props: Props) => {
  const { attachment, isWide, onClick } = props;

  return (
    <StyledDiv isWide={isWide}>
      <StyledSpan isWide={isWide}>
        {attachment.fileName}
        <DeleteStyledSpan onClick={() => onClick(attachment)} />
        <DisableStyledSpan />
      </StyledSpan>
    </StyledDiv>
  );
};
